export enum NotificationTypeEnum {
  info = "info",
  success = "success",
  warning = "warning",
  error = "error",
  none = "none",
}
